"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var financeSummaryDisclaimerStyles = styles_1.makeStyles(function () { return ({
    wrapper: {
        marginTop: 60,
    },
    text: {
        '& > *': {
            marginBottom: 15,
        },
    },
}); }, {
    name: 'GqlSummary_FinanceSummaryDisclaimer',
});
exports.default = financeSummaryDisclaimerStyles;
